import request from '@/utils/request'


// 查询名校信息列表
export function listPrestigiousSchool(query) {
  return request({
    url: '/doctor/prestigiousSchool/list',
    method: 'get',
    params: query
  })
}

// 查询名校信息分页
export function pagePrestigiousSchool(query) {
  return request({
    url: '/doctor/prestigiousSchool/page',
    method: 'get',
    params: query
  })
}

// 查询名校信息详细
export function getPrestigiousSchool(data) {
  return request({
    url: '/doctor/prestigiousSchool/detail',
    method: 'get',
    params: data
  })
}

// 新增名校信息
export function addPrestigiousSchool(data) {
  return request({
    url: '/doctor/prestigiousSchool/add',
    method: 'post',
    data: data
  })
}

// 修改名校信息
export function updatePrestigiousSchool(data) {
  return request({
    url: '/doctor/prestigiousSchool/edit',
    method: 'post',
    data: data
  })
}

// 删除名校信息
export function delPrestigiousSchool(data) {
  return request({
    url: '/doctor/prestigiousSchool/delete',
    method: 'post',
    data: data
  })
}
